const DotSeparator = () => {
    return (
        <span
            style={{
                display: 'block',
                width: 4,
                height: 4,
                borderRadius: '50%',
                backgroundColor: 'var(--gray-6)',
            }}
        />
    );
};

export default DotSeparator;
